/* Aurelia theme – vanilla JS */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- helpers ---------- */
  function money(cents) {
    var f = T.moneyFormat || '${{amount}}';
    function fmt(n, p, t, d) {
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  /* ---------- drawers / overlay / modal ---------- */
  var overlay = $('[data-overlay]');
  function lock(on) { document.body.classList.toggle('is-locked', on); }
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    closeAll();
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    lock(true);
  }
  function closeAll() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    var m = $('#QuickView'); if (m) m.hidden = true;
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('filters-open', 'sort-open');
    lock(false);
  }
  function openModal() { var m = $('#QuickView'); if (!m) return; m.hidden = false; lock(true); }

  /* ---------- search ---------- */
  function toggleSearch(force) {
    var bar = $('[data-searchbar]'); if (!bar) return;
    var open = typeof force === 'boolean' ? force : !bar.classList.contains('is-open');
    bar.classList.toggle('is-open', open);
    if (open) { var i = $('[data-search-input]', bar); if (i) setTimeout(function () { i.focus(); }, 50); }
  }
  var runSearch = debounce(function (input) {
    var out = $('[data-search-results]'); if (!out) return;
    var q = input.value.trim();
    if (q.length < 2) { out.innerHTML = ''; return; }
    var url = T.routes.predictive + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,article&resources[limit]=6&section_id=predictive-search';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var ps = $('[data-ps]', parseHTML(html));
      out.innerHTML = ps ? ps.innerHTML : '';
    }).catch(function () {});
  }, 250);

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
  }
  function refreshCart(open) {
    return Promise.all([
      fetch(T.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }),
      fetch(T.routes.cart + '.js').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var doc = parseHTML(res[0]['cart-drawer']);
      var fresh = $('.cart-drawer__inner', doc), cur = $('.cart-drawer__inner');
      if (fresh && cur) cur.replaceWith(fresh);
      setCount(res[1].item_count);
      if (open) openDrawer('CartDrawer');
      return res[1];
    });
  }
  function addToCart(form) {
    var btn = $('[data-add-btn]', form), err = $('[data-buy-error]', form);
    if (err) err.hidden = true;
    if (btn) btn.disabled = true;
    var fd = new FormData(form);
    return fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || T.strings.error);
        if (T.cartType === 'page') { window.location.href = T.routes.cart; return; }
        closeModalOnly();
        return refreshCart(true).then(function () { toast(T.strings.added); });
      })
      .catch(function (e) { if (err) { err.textContent = e.message; err.hidden = false; } else toast(e.message); })
      .then(function () { if (btn) btn.disabled = false; });
  }
  function closeModalOnly() { var m = $('#QuickView'); if (m) m.hidden = true; }
  function changeLine(line, qty) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    }).then(function (r) { return r.json(); }).then(function () { return refreshCart(false); });
  }

  /* ---------- product (variants / gallery / qty) ---------- */
  function initProduct(root) {
    if (!root || root._ready) return; root._ready = true;
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-btn]', root), addLabel = $('[data-add-label]', root);
    var priceBox = $('[data-price]', root), sku = $('[data-sku]', root), stock = $('[data-stock]', root);
    var noUrl = root.hasAttribute('data-no-url');

    function selected() {
      var vals = [];
      $$('input[data-option-index]:checked,select[data-option-index]', root).forEach(function (el) { vals[+el.getAttribute('data-option-index')] = el.value; });
      return vals;
    }
    function findVariant(vals) {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); })[0];
    }
    var stage = $('.gallery__stage', root);
    function isMob() { return window.matchMedia && window.matchMedia('(max-width: 899px)').matches; }
    function syncCount(i) {
      var c = $('[data-gallery-count]', root);
      if (c) c.textContent = (i + 1) + ' / ' + $$('[data-media-id]', root).length;
      $$('.gallery__dots i', root).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function activate(id) {
      var slides = $$('[data-media-id]', root), idx = 0;
      slides.forEach(function (s, k) { var on = s.getAttribute('data-media-id') === String(id); if (on) idx = k; s.classList.toggle('is-active', on); });
      $$('[data-thumb]', root).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-thumb') === String(id)); });
      if (stage && isMob() && slides[idx]) stage.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
      syncCount(idx);
    }
    if (stage) {
      var raf;
      stage.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { if (isMob() && stage.clientWidth) syncCount(Math.round(stage.scrollLeft / stage.clientWidth)); });
      }, { passive: true });
    }
    var ci = -1;
    (product.options || []).forEach(function (o, i) { var n = typeof o === 'string' ? o : o.name; if (/colou?r/i.test(n)) ci = i; });
    var cvals = {};
    if (ci > -1) product.variants.forEach(function (v) { cvals[String(v.options[ci]).toLowerCase()] = 1; });
    function tagOf(el) {
      var a = (el.getAttribute('data-alt') || ''), k = a.lastIndexOf(' - ');
      var t = (k > -1 ? a.slice(k + 3) : '').trim().toLowerCase();
      return cvals[t] ? t : '';
    }
    function filterGallery(c) {
      if (ci < 0 || !c) return;
      c = String(c).toLowerCase();
      var curOff = false, firstOn = null;
      $$('[data-media-id],[data-thumb]', root).forEach(function (el) {
        var t = tagOf(el), off = !!t && t !== c;
        el.classList.toggle('is-off', off);
        var id = el.getAttribute('data-media-id') || el.getAttribute('data-thumb');
        if (!off && !firstOn && el.hasAttribute('data-media-id')) firstOn = id;
        if (off && el.classList.contains('is-active')) curOff = true;
      });
      var vis = $$('[data-media-id]:not(.is-off)', root).length;
      var cnt = $('[data-gallery-count]', root); if (cnt) cnt.textContent = '1 / ' + vis;
      var nav = $$('[data-gallery-nav]', root); nav.forEach(function (b) { b.style.display = vis > 1 ? '' : 'none'; });
      if (curOff && firstOn) activate(firstOn);
    }
    function update() {
      var vals = selected();
      if (ci > -1) filterGallery(vals[ci]);
      vals.forEach(function (v, i) { var l = $('[data-option-label="' + i + '"]', root); if (l) l.textContent = v; });
      var v = findVariant(vals);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = T.strings.unavailable;
        return;
      }
      if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (priceBox) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        priceBox.innerHTML = '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__current">' + money(v.price) + '</span>' +
          (sale ? '<s class="price__compare">' + money(v.compare_at_price) + '</s><span class="price__off">(' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF)</span>' : '') + '</div>';
      }
      if (sku) sku.textContent = v.sku || '–';
      if (stock) {
        stock.innerHTML = v.available ? '<span class="dot dot--ok"></span> In stock' : '<span class="dot dot--out"></span> Out of stock';
      }
      if (v.featured_media && v.featured_media.id) activate(v.featured_media.id);
      else if (ci > -1) { var a0 = $('[data-media-id]:not(.is-off)', root); if (a0) activate(a0.getAttribute('data-media-id')); }
      if (!noUrl && window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    if (ci > -1) { var iv = selected(); if (iv[ci]) { filterGallery(iv[ci]); var f0 = $('[data-media-id]:not(.is-off)', root); if (f0 && $('[data-media-id].is-active.is-off', root)) activate(f0.getAttribute('data-media-id')); } }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-option-index]')) update(); });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) activate(t.getAttribute('data-thumb'));
      var nv = e.target.closest('[data-gallery-nav]');
      if (nv) {
        var sl = $$('[data-media-id]:not(.is-off)', root), cur = 0;
        sl.forEach(function (x, k) { if (x.classList.contains('is-active')) cur = k; });
        var n = (cur + parseInt(nv.getAttribute('data-gallery-nav'), 10) + sl.length) % sl.length;
        activate(sl[n].getAttribute('data-media-id'));
      }
    });
    var form = $('form[data-product-form]', root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (addBtn && addBtn.disabled) return; addToCart(form); });
  }
  function initProducts(ctx) { $$('[data-product-root]', ctx).forEach(initProduct); }

  /* ---------- wishlist ---------- */
  var KEY = 'aurelia_wishlist';
  function wishlist() { return store.get(KEY, []); }
  function syncWishlist() {
    var list = wishlist();
    $$('[data-wishlist-toggle]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on);
    });
    $$('[data-wishlist-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });
  }
  function toggleWishlist(handle) {
    var list = wishlist(), i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); toast(T.strings.wishlistRemoved); } else { list.push(handle); toast(T.strings.wishlistAdded); }
    store.set(KEY, list); syncWishlist();
    if ($('[data-wishlist-grid]')) renderWishlist();
  }
  function renderWishlist() {
    var grid = $('[data-wishlist-grid]'), empty = $('[data-wishlist-empty]'); if (!grid) return;
    var list = wishlist();
    empty.hidden = list.length > 0;
    Promise.all(list.map(function (h) {
      return fetch(T.routes.products + h + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (cards) { grid.innerHTML = cards.join(''); syncWishlist(); });
  }

  /* ---------- quick view ---------- */
  function quickView(handle) {
    var body = $('[data-quickview-body]'); if (!body) return;
    body.innerHTML = '<div class="empty">Loading…</div>';
    openModal();
    fetch(T.routes.products + handle + '?view=quick').then(function (r) { return r.text(); }).then(function (html) {
      body.innerHTML = html; initProducts(body); syncWishlist();
    }).catch(function () { closeModalOnly(); lock(false); toast(T.strings.error); });
  }

  /* ---------- ajax filtering ---------- */
  var GRID_KEY = 'aurelia_grid_cols';
  function applyGrid() {
    var cols = store.get(GRID_KEY, null);
    $$('[data-product-grid]').forEach(function (g) {
      g.classList.remove('cols-1', 'cols-2', 'cols-3', 'cols-4');
      if (cols) g.classList.add('cols-' + cols);
    });
    $$('[data-grid-cols]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-grid-cols') === String(cols)); });
  }
  function loadResults(url, push) {
    var wrap = $('[data-ajax-results]'); if (!wrap) { window.location.href = url; return; }
    var open = $$('details[data-filter]', wrap).map(function (d) { return d.open; });
    wrap.classList.add('is-loading');
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var fresh = $('[data-ajax-results]', parseHTML(html));
      if (fresh) {
        wrap.innerHTML = fresh.innerHTML;
        $$('details[data-filter]', wrap).forEach(function (d, i) { if (open[i] !== undefined) d.open = open[i]; });
      }
      if (push) history.pushState({}, '', url);
      document.body.classList.remove('filters-open', 'sort-open'); lock(false);
      applyGrid(); syncWishlist();
    }).catch(function () { window.location.href = url; })
      .then(function () { wrap.classList.remove('is-loading'); });
  }
  function submitFilters(form) {
    var fd = new FormData(form), p = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
    loadResults(new URL(form.action).pathname + '?' + p.toString(), true);
  }

  /* ---------- slideshow / rotator ---------- */
  function initSlideshow(el) {
    var slides = $$('.hero__slide', el), dots = $$('[data-slide-dot]', el), i = 0, timer;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        var v = s.querySelector('video');
        if (v) { if (k === i) { try { v.currentTime = 0; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {} } else { v.pause(); } }
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() {
      var s = parseInt(el.getAttribute('data-autoplay'), 10); clearInterval(timer); clearTimeout(timer);
      var v = slides[i] && slides[i].querySelector('video');
      if (v && s > 0) { timer = setTimeout(function () { go(i + 1); play(); }, Math.max(((v.duration || 12) * 1000) + 300, s * 1000)); return; }
      if (s > 0) timer = setInterval(function () { go(i + 1); play(); }, s * 1000);
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-slide-next]')) { go(i + 1); play(); }
      else if (e.target.closest('[data-slide-prev]')) { go(i - 1); play(); }
      else { var d = e.target.closest('[data-slide-dot]'); if (d) { go(+d.getAttribute('data-slide-dot')); play(); } }
    });
    var sx = 0;
    el.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) { go(i + (dx < 0 ? 1 : -1)); play(); } });
    play();
  }
  function initRotator(el) {
    var items = $$('.announce__item', el), i = 0;
    if (items.length < 2) return;
    setInterval(function () {
      items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
    }, (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000);
  }

  /* ---------- recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el._ready) return; el._ready = true;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = $('[data-recommendations]', parseHTML(html));
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; syncWishlist(); }
      }).catch(function () {});
    });
  }

  /* ---------- global events ---------- */
  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-open-drawer]'))) { openDrawer(t.getAttribute('data-open-drawer')); return; }
    if (e.target.closest('[data-close-drawer]') || e.target === overlay) { closeAll(); return; }
    if (e.target.closest('[data-close-modal]') || e.target.id === 'QuickView') { closeAll(); return; }
    if ((t = e.target.closest('[data-cart-toggle]')) && T.cartType === 'drawer') { e.preventDefault(); refreshCart(true); return; }
    if (e.target.closest('[data-toggle-search]')) { e.preventDefault(); toggleSearch(); return; }
    if ((t = e.target.closest('[data-quick-view]'))) { e.preventDefault(); quickView(t.getAttribute('data-quick-view')); return; }
    if ((t = e.target.closest('[data-wishlist-toggle]'))) { e.preventDefault(); toggleWishlist(t.getAttribute('data-wishlist-toggle')); return; }
    if ((t = e.target.closest('[data-cart-qty]'))) { e.preventDefault(); changeLine(t.getAttribute('data-line'), t.getAttribute('data-quantity')); return; }
    if ((t = e.target.closest('[data-qty-btn]'))) {
      var input = $('.qty__input', t.closest('.qty')); if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 1;
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(t.getAttribute('data-qty-btn'), 10));
      if (input.hasAttribute('data-auto-submit')) { var f = input.form; if (f) { var b = document.createElement('input'); b.type = 'hidden'; b.name = 'update'; b.value = 'Update'; f.appendChild(b); f.submit(); } }
      return;
    }
    if (e.target.closest('[data-open-filters]')) { document.body.classList.add('filters-open'); lock(true); return; }
    if (e.target.closest('[data-apply-filters]')) { var ff = $('[data-filter-form]'); document.body.classList.remove('filters-open'); lock(false); if (ff) submitFilters(ff); return; }
    if (e.target.closest('[data-close-filters]')) {
      document.body.classList.remove('filters-open'); lock(false);
      if (!e.target.closest('a[data-ajax-link]')) return;
    }
    if (e.target.closest('[data-open-sort]')) { document.body.classList.add('sort-open'); lock(true); return; }
    if (e.target.closest('[data-close-sort]')) { document.body.classList.remove('sort-open'); lock(false); return; }
    if ((t = e.target.closest('[data-facet-tab]'))) {
      var idx = t.getAttribute('data-facet-tab'), pane = t.closest('.fpane');
      $$('[data-facet-tab]', pane).forEach(function (b) { b.classList.toggle('is-active', b === t); });
      $$('[data-facet-panel]', pane).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-facet-panel') === idx); });
      var panels = $('.fpanels', pane); if (panels) panels.scrollTop = 0;
      return;
    }
    if ((t = e.target.closest('[data-mmenu-tab]'))) {
      var mi = t.getAttribute('data-mmenu-tab'), mm = t.closest('.mmenu');
      $$('[data-mmenu-tab]', mm).forEach(function (b) { b.classList.toggle('is-active', b === t); });
      $$('[data-mmenu-panel]', mm).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mmenu-panel') === mi); });
      var mp = $('.mmenu__panels', mm); if (mp) mp.scrollTop = 0;
      return;
    }
    if ((t = e.target.closest('[data-grid-cols]'))) { store.set(GRID_KEY, t.getAttribute('data-grid-cols')); applyGrid(); return; }
    if ((t = e.target.closest('a[data-ajax-link]'))) { e.preventDefault(); loadResults(t.href, true); return; }
    if ((t = e.target.closest('[data-toggle-recover]'))) {
      e.preventDefault();
      var rec = $('#recover'), login = $('#login');
      if (rec && login) { var show = t.getAttribute('href') === '#recover'; rec.hidden = !show; login.hidden = show; }
      return;
    }
    if ((t = e.target.closest('[data-delete-address]'))) {
      if (window.confirm('Delete this address?') && window.Shopify && Shopify.postLink) {
        Shopify.postLink(t.getAttribute('data-delete-address'), { parameters: { _method: 'delete' } });
      }
      return;
    }
    if (e.target.closest('[data-to-top]')) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var bar = $('[data-searchbar].is-open');
    if (bar && !e.target.closest('[data-searchbar]') && !e.target.closest('[data-toggle-search]')) toggleSearch(false);
  });

  document.addEventListener('change', function (e) {
    var f = e.target.form;
    if (e.target.matches('[data-sort-radio]')) {
      var sf = $('[data-filter-form]'), sp = new URLSearchParams(sf ? new FormData(sf) : '');
      sp.set('sort_by', e.target.value);
      var clean = new URLSearchParams(); sp.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      loadResults((sf ? new URL(sf.action).pathname : window.location.pathname) + '?' + clean.toString(), true);
      return;
    }
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 899px)').matches;
    if (f && f.matches && f.matches('[data-filter-form]') && !e.target.matches('[data-country-select]')) {
      if (isMobile && !e.target.matches('[data-sort]')) return; /* mobile: apply with the Apply button */
      submitFilters(f);
    }
    if (e.target.matches('[data-auto-submit]') && e.target.form) { e.target.form.submit(); }
  });
  document.addEventListener('input', function (e) { if (e.target.matches('[data-search-input]')) runSearch(e.target); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); toggleSearch(false); }
  });
  window.addEventListener('popstate', function () { if ($('[data-ajax-results]')) loadResults(window.location.href, false); });
  window.addEventListener('storage', syncWishlist);

  var toTop = $('[data-to-top]'), header = $('[data-header]');
  window.addEventListener('scroll', function () {
    if (toTop) toTop.classList.toggle('is-visible', window.scrollY > 600);
  }, { passive: true });

  /* ---------- country/province selector (account addresses) ---------- */
  function initCountrySelectors() {
    if (!window.Shopify || !Shopify.CountryProvinceSelector) return;
    $$('[data-country-select]').forEach(function (c) {
      if (c._ready) return; c._ready = true;
      new Shopify.CountryProvinceSelector(c.id, c.getAttribute('data-province-id'), { hideElement: null });
      var d = c.getAttribute('data-default'); if (d) { c.value = d; c.dispatchEvent(new Event('change')); }
      var p = document.getElementById(c.getAttribute('data-province-id'));
      if (p && p.getAttribute('data-default')) setTimeout(function () { p.value = p.getAttribute('data-default'); }, 50);
    });
  }

  /* ---------- init ---------- */
  function init() {
    $$('[data-slideshow]').forEach(initSlideshow);
    $$('[data-rotator]').forEach(initRotator);
    initProducts(document);
    initRecommendations();
    applyGrid(); syncWishlist(); renderWishlist();
    window.addEventListener('load', initCountrySelectors);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-slideshow]', e.target).forEach(initSlideshow);
    $$('[data-rotator]', e.target).forEach(initRotator);
    initProducts(e.target); initRecommendations(); applyGrid(); syncWishlist();
  });

/* custom sort dropdown */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-sortdd-btn]'),o=e.target.closest('[data-sortdd-opt]'),open=document.querySelector('[data-sortdd].is-open');
  if(o){var w=o.closest('[data-sortdd]'),sel=w.querySelector('select');w.classList.remove('is-open');sel.value=o.getAttribute('data-sortdd-opt');sel.dispatchEvent(new Event('change',{bubbles:true}));return}
  if(b){var w2=b.closest('[data-sortdd]'),was=w2.classList.contains('is-open');if(open)open.classList.remove('is-open');w2.classList.toggle('is-open',!was);b.setAttribute('aria-expanded',String(!was));return}
  if(open)open.classList.remove('is-open');
});

/* price range slider */
document.addEventListener('input',function(e){
  var el=e.target; if(!el.matches||!el.matches('[data-prange-lo],[data-prange-hi]'))return;
  var w=el.closest('[data-prange]'),lo=w.querySelector('[data-prange-lo]'),hi=w.querySelector('[data-prange-hi]'),max=+lo.max,sym=w.getAttribute('data-symbol')||'';
  var a=+lo.value,b=+hi.value;
  if(a>b){ if(el===lo){a=b;lo.value=a}else{b=a;hi.value=b} }
  w.style.setProperty('--lo',a*100/max);w.style.setProperty('--hi',b*100/max);
  w.querySelector('[data-prange-lo-label]').textContent=sym+a;w.querySelector('[data-prange-hi-label]').textContent=sym+b;
  var body=w.parentNode,n=body.querySelectorAll('.facet__price input');
  if(n[0])n[0].value=a>0?a:'';if(n[1])n[1].value=b<max?b:'';
  hi.style.zIndex=(a>max*0.9)?1:'';lo.style.zIndex=(a>max*0.9)?2:'';
});

/* price preset chips */
document.addEventListener('click',function(e){
  var c=e.target.closest&&e.target.closest('[data-price-preset]'); if(!c)return;
  var body=c.closest('.facet__body'),n=body.querySelectorAll('.facet__price input'); if(n.length<2)return;
  var on=c.classList.contains('is-on');
  body.querySelectorAll('[data-price-preset]').forEach(function(x){x.classList.remove('is-on')});
  n[0].value=on?'':c.getAttribute('data-min'); n[1].value=on?'':c.getAttribute('data-max');
  if(!on)c.classList.add('is-on');
  n[1].dispatchEvent(new Event('change',{bubbles:true}));
});
})();
